import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { get } from '../../api';

interface PublicUser {
  id: string;
  username: string;
}

export default function UserPage() {
  const { id } = useParams();
  const [user, setUser] = useState<PublicUser | null | undefined>(undefined);

  useEffect(() => {
    get<PublicUser | null>(`users/${id}`)
      .then(setUser)
      .catch(() => setUser(null));
  }, [id]);

  return (
    <div>
      <div className="columns">
        <div className="column is-half is-offset-one-quarter has-text-centered">
          {user === undefined && <p>Loading...</p>}
          {user === null && <p>User not found.</p>}
          {user && <h2 className="title is-3">{user.username}</h2>}
        </div>
      </div>
    </div>
  );
}
